import { render, staticRenderFns } from "./index-web.vue?vue&type=template&id=22c2abec&scoped=true"
import script from "./index-web.vue?vue&type=script&lang=ts"
export * from "./index-web.vue?vue&type=script&lang=ts"
import style0 from "./style/index.scss?vue&type=style&index=0&id=22c2abec&prod&lang=scss&scoped=true&external"
import style1 from "./index-web.vue?vue&type=style&index=1&id=22c2abec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c2abec",
  null
  
)

export default component.exports